import React, { useEffect, useState, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./AddDoctorPopup.css";
import api from "./../../../axiosInstance"
import logger from "../../../utils/logger";

const AddDoctorPopup = ({ open, setAddDoctorPopup, onSubmit }) => {
  const popupRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [searchDoctorsData, setSearchDoctorsData] = useState([]);

  const fetchSearchDoctorsAPI = async (searchQuery) => {
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/search/doctors?searchQuery=${searchQuery}`;
    logger.debug("apiUrl:", apiUrl);
    try {
      const response = await api.get(`/search/doctors`,{
        params: {
          searchQuery:searchQuery
        }
      })

      const data = response.data
      await setSearchDoctorsData(data);
      logger.debug("SEARCH DR. DATA:", data);
    } catch (error) {
      logger.error("Error fetching search doctors data:", error);
    }
  };

  useEffect(() => {
    fetchSearchDoctorsAPI(searchQuery);
  }, [searchQuery]);

  const handleSearchChange = (event) => {
    const searchQuery = event.target.value;
    logger.debug(searchQuery)
    setSearchQuery(searchQuery);
  };

  const handleSelectDoctor = (doctor) => {
    setSelectedDoctor(doctor);
    setSearchQuery(`${doctor.name.firstName} ${(doctor.name.middleName || "")} ${doctor.name.lastName}`);
    setSearchDoctorsData([]);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (selectedDoctor) {
      onSubmit(selectedDoctor);
      setAddDoctorPopup(false);
    } else {
      alert("Please select a doctor from the search results.");
    }
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setAddDoctorPopup(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="overlay_page-search-doctor">
      <div className="search__doctor-container" ref={popupRef}>
        <div className="doctor__cross-icon_container" onClick={() => setAddDoctorPopup(false)}>
          <CloseIcon className="cross_icon-image" />
        </div>
        <div className="search__doctor-content">
          <h2>Search Doctor</h2>
          <div className="search__doctor-content-section">
            <p>Enter Doctor's Name or Specialization</p>
            <input
              type="text"
              placeholder="Search Doctor Name/Specialization"
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <div>
            {searchDoctorsData?.message?.length > 0 ? (
              searchDoctorsData.message.map((doctor, index) => (
                <div className="search-card-appointment_calendar" key={index} onClick={() => handleSelectDoctor(doctor)}>
                  <div className="search-section-appointment_calendar">
                    {/* <img src={doctor.img} alt={doctor.name.firstName} /> */}
                    <p>{doctor.name.firstName} {doctor.name.lastName}</p>
                    <p>{doctor.specialization}</p>
                  </div>
                </div>
              ))
            ) : (
              <p>No results found</p>
            )}
          </div>
          <button className="search-button" onClick={handleFormSubmit}>Add</button>
        </div>
      </div>
    </div>
  );
};

export default AddDoctorPopup;
